import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-uploading-spinner',
  templateUrl: './uploading-spinner.component.html',
  styleUrls: ['./uploading-spinner.component.scss']
})
export class UploadingSpinner implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
